<template>
  <div class="qr-code-wrapper relative border border-secondary-20 p-4 rounded-lg">
    <img class="qr-code" :src="qrCodeImageUrl">
    <aha-spinner class="loading-layer" variant="dark" v-if="isLoading" />
  </div>
</template>
<script>
export default {
  props: {
    qrCodeImageUrl: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="scss" scoped>
.qr-code-wrapper {
    --width: 180px;
    min-width: var(--width);
    width: var(--width);
    max-width: var(--width);
    aspect-ratio: 1;

    & > .qr-code {
        --width: 148px;
        min-width: var(--width);
        width: var(--width);
        max-width: var(--width);
        aspect-ratio: 1;
    }
}

.loading-layer {
  @apply absolute inset-0 flex justify-center items-center rounded-lg;
  background-color: rgba(255, 255, 255, 0.8);
}
</style>
